import { css } from '@emotion/react';
import React from 'react';
import { semantic_colors } from '../../foundation';
import { IconArrowChevronLeft, IconArrowChevronRight } from '../icons/generated';
import { useProviderConfig } from '../provider';
import { pagination_button_css, pagination_button_default_style, pagination_button_disabled_style } from './styles';

type PaginationArrowPosition = 'prev' | 'next';

export interface PaginationArrowProps {
  /** @default 'prev' */
  position?: PaginationArrowPosition;
  disabled?: boolean;
  onClick?: () => void;
}

export const PaginationArrow = ({ position = 'prev', disabled, onClick }: PaginationArrowProps) => {
  const { locale } = useProviderConfig();
  const positionText = position === 'prev' ? locale?.accessibility.prev : locale?.accessibility.next;
  const ariaLabel =
    locale?.lang === 'en-US'
      ? `${locale?.accessibility.page} ${positionText}`
      : `${positionText} ${locale?.accessibility.page}`;
  const color = disabled ? semantic_colors.content.disabled : semantic_colors.content.secondary;

  return (
    <button
      type='button'
      aria-label={ariaLabel}
      css={[
        pagination_button_css,
        pagination_button_default_style,
        css`
          cursor: ${disabled ? 'default' : 'pointer'};
          ${disabled && pagination_button_disabled_style}
        `,
      ]}
      disabled={disabled}
      onClick={onClick}
    >
      {position === 'prev' ? (
        <IconArrowChevronLeft color={color} size={20} />
      ) : (
        <IconArrowChevronRight color={color} size={20} />
      )}
    </button>
  );
};
